export const MAPBOX_KEY =
    "pk.eyJ1IjoiamFzc21pdGg4NyIsImEiOiJjanllMWE0Y2owc2k3M2RvY3o3MXlxbDZxIn0.EQJsvDixbUz2naDzTIfE6Q";

export const GOOGLE_MAP_KEY = "AIzaSyDjgwR1n2vWcjNc0nj0_XRjLEhty3dNnCg";
export const GOOGLE_GEOCODE_KEY = "AIzaSyCYMju7EWhy5Q1L0BI364EJosxBdex5SL8";

export const iconImageStorageFolder = "icon-images";
